export default __webpack_public_path__ + "media/images/favicon/apple-touch-icon-144x144-49349e960a46b8c46a1ecf9a63ba4680.png";